// assets/team-search.js
window.FrenzyTeamSearch = function (options) {
  const {
    searchInput,
    teamsListWrap,
    searchClass,
    authUrl_Frenzy,
    frenzy_api_key,
    frenzyShop,
    user_id_Frenzy,
    frenzy_state,
    frenzy_company_id,
    frenzy_location_id,
    frenzy_session_id,
    shopAllUrl,
    placeholderImg,
    menuMode,
    teamData
  } = options;
  if (!searchInput || !teamsListWrap) return;
  const getCollection = searchInput.getAttribute("data-collection").split("/collections/")[1];
  
  const debounce = (fn, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const handleize = (str) =>
    str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

  const filterTeams = async () => {
    const searchValue = searchInput.value.trim().toLowerCase();
    if (searchValue.length < 2) {
      teamsListWrap.innerHTML = "";
      // return;
    }

    const loaderHTML = `
      <div class="team-spinner">
        <svg class="spinner" width="30" height="30" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="18"></circle>
        </svg>
      </div>
    `;

    try {
      teamsListWrap.innerHTML = loaderHTML;
      let params = {
        sort: "best match",
        user_id: user_id_Frenzy.toString(),
        collection_id: null,
        collection_handle: getCollection,
        shop: frenzyShop,
        mode: 2,
        page_index: 0,
        config_id: null,
        ab_test_id: null,
        currency: Shopify?.currency?.active || "",
        country: Shopify.country || "",
        state: frenzy_state || "",
        company_id: frenzy_company_id || "",
        location_id: frenzy_location_id || "",
        session_id: frenzy_session_id || "",
        raw_query: searchInput.value.toLowerCase(),
        filters: "collections:" + encodeURIComponent(getCollection),
      };

      const queryString = new URLSearchParams(params).toString();
      const productRequestURL = `${authUrl_Frenzy}/collection-search?${queryString}`;
      const response = await fetch(productRequestURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-frenzy-authorization": frenzy_api_key,
          "X-Shop": frenzyShop,
        },
      });

      const data = await response.json();
      if (data.status === 200) {
        const facet_fields_obj = data?.data?.results?.facet_fields;
        const productTypeData = facet_fields_obj?.s_product_type || [];
        const colorSwatches = data?.data?.results?.color_swatches;

        let teamHTML = "";
        let teamCount = 0;
        const filteredList = productTypeData
          .filter(([name]) => !name.toUpperCase().includes("KIDS"))
          .map(([name]) => name);
        filteredList.forEach((team) => {
          teamCount++;
          const matchedTeam = (teamData || []).find(
            (t) => team === t.name.toUpperCase()
          );
          const collUrl = matchedTeam
            ? matchedTeam.url
            : `/collections/${searchClass}${handleize(team)}`;

          const key = `s_product_type:${team}`;
          const getColorImg = matchedTeam?.image ? matchedTeam?.image : colorSwatches[key]?.color_img;
          const isMoreThan36 = teamCount > 36;
          const imageSizeStyle = isMoreThan36
            ? "height: 45px; width: 45px;display: flex;"
            : "height: 50px; width: 50px;display: flex;";
          const imageClass = isMoreThan36
            ? "teams-nav-image-more-teams"
            : "teams-nav-image";
          const isPlaceholder = !getColorImg;
          const imageClassFinal = `${imageClass} ${isPlaceholder ? 'placeholder-image' : ''}`;
          if (teamCount <= 36 && menuMode === "desktop") {
            teamHTML += `
              <div class="navtext__image ${searchClass}teams-search-item">
                <div style="${imageSizeStyle}">
                  <img loading="lazy" src='${
                    getColorImg || placeholderImg
                  }' alt="${team}" width="40" height="40" class="${imageClass} ${imageClassFinal}">
                </div>
                <a href="${collUrl}" class="navlink navlink--grandchild">
                  <span class="navtext">${team}</span>
                </a>
              </div>`;
          }else if(teamCount <= 36 && menuMode === "mobile"){
            teamHTML += `<li class="mobile-menu__item navtext__image mobile-menu__item--level-3">
                            <div style="${imageSizeStyle}">
                                        <img loading="lazy" src='${
                    getColorImg || placeholderImg
                  }' alt="${team}" width="40" height="40" class="${imageClass} ${imageClassFinal}">
                            </div>
                        <a href="${collUrl}" class="mobile-navlink mobile-navlink--level-3">
                            ${team}
                        </a>
                        </li>`;
          }
        });

        if (teamCount >= 36 && menuMode === "desktop") {
          teamHTML += `
            <div class="navtext__image view-all" style="justify-content: flex-start !important;flex-wrap: wrap;">
              <p style="font-weight: 600; margin-bottom: 10px; color: #000;width: 100%;text-align: left;">
                Over 300+ Teams available
              </p>
              <a href="${shopAllUrl}" style="display: inline-block; padding: 10px 20px; background: #212b36; color: white; border-radius: 4px; text-decoration: none;">
                SHOP ALL TEAMS
              </a>
            </div>`;
        }else if(teamCount >= 36 && menuMode === "mobile"){
            teamHTML += `
              <div class="navtext__image view-all" style="justify-content: flex-start !important;flex-wrap: wrap;">
                  <p style="font-weight: 600; margin-bottom: 10px; color: #000;width: 100%;text-align: left;">
                      Over 300+ Teams available
                  </p>
                  <a href="${shopAllUrl}" style="display: inline-block; padding: 10px 20px; background: #212b36; color: white; border-radius: 4px; text-decoration: none;">
                      SHOP ALL TEAMS
                  </a>
              </div>`;
        }

        teamsListWrap.innerHTML = teamHTML;
      }
    } catch (err) {
      console.error("Error loading teams:", err);
      teamsListWrap.innerHTML =
        `<div style="padding: 20px; color: red;">Something went wrong. Please try again later.</div>`;
    }
  };

  const debouncedFilterTeams = debounce(filterTeams, 300);
  searchInput.addEventListener("input", (e) => {
      debouncedFilterTeams();
  });
  debouncedFilterTeams();
};
